import { createFileRoute } from "@tanstack/react-router";

import { AdjustmentDetailPage } from "../../../../features/inventory/adjustment-detail-page";

export const Route = createFileRoute("/_app/inventory/adjustments/$id")({ component: AdjustmentRoute });

function AdjustmentRoute() {
  const { id } = Route.useParams();
  return <AdjustmentDetailPage key={id} id={id} />;
}
